import { render, staticRenderFns } from "./add.vue?vue&type=template&id=575b531b"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575b531b')) {
      api.createRecord('575b531b', component.options)
    } else {
      api.reload('575b531b', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=575b531b", function () {
      api.rerender('575b531b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/customer/add.vue"
export default component.exports